import React, { Fragment, useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Btn, H5, Spinner } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import { Col } from "reactstrap";
import AddModal from "./AddModal";
import EditModal from "./EditModal";
import EventDelete from "../../CommonElements/EventDeleteModal";
import { fetchEvents, deleteEvent } from "../../Redux/stateSlice/eventListReducer";

const DataTableComponent = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [viewData, setViewData] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [isDelete, setIsDelete] = useState(false);
  const [deleteEventId, setDeleteEventId] = useState(null);

  
  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const dispatch = useDispatch();
  const stateEvents = useSelector((state) => state.events);
  console.log("state events", stateEvents);

  const { loading, events, error } = stateEvents;

  // fetch events once (not server paginated)
  useEffect(() => {
    dispatch(fetchEvents()); 
  }, [dispatch]);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = (id) => {
    setDeleteEventId(id);
    setIsDelete(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteEventId) return;

    try {
      setIsDelete(false);
      await dispatch(deleteEvent(deleteEventId)).unwrap();
      dispatch(fetchEvents()); // refresh all
      setDeleteEventId(null);
      setSelectedRows([]);
      setToggleDelet((prev) => !prev);
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const EditModaltoggle = (data) => {
    setViewData(data);
    setEditModal(!editModal);
  };

  const Modaltoggle = () => setViewModal(!viewModal);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <Col className="vh-100 d-flex align-items-center justify-content-center">
        <div className="loader-box">
          <Spinner attrSpinner={{ className: "loader-5" }} />
        </div>
      </Col>
    );
  }
  console.log("Error in event list:", error);

  const CustomOption = ({ row }) => (
    <div className="d-flex">
      {/* Uncomment if edit is required */}
      {/* <button
        className="btn btn-light p-2 mx-1"
        onClick={() => EditModaltoggle(row)}
      >
        <i className="fa fa-edit" style={{ fontSize: "large", color: "#494949" }}></i>
      </button> */}
      <button
        className="btn btn-light p-2 mx-1"
        onClick={() => handleDelete(row._id)}
      >
        <i
          className="fa fa-trash-o"
          style={{ fontSize: "large", color: "#494949" }}
        ></i>
      </button>
    </div>
  );

  const tableColumns = [
    { name: "Title", selector: (row) => row.title, sortable: true, center: true },
    {
      name: "Event Date",
      selector: (row) => row.eventDate,
      sortable: true,
      center: true,
    },
    {
      name: "Event Time",
      selector: (row) => row.eventTime,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.company,
      sortable: true,
      cell: () => <span className="badge badge-light-success">Active</span>,
      center: true,
    },
    {
      name: "Option",
      center: true,
      minWidth: "150px",
      button: true,
      cell: (row) => <CustomOption row={row} />,
    },
  ];

  // ✅ slice data for client-side pagination
  const allEvents = Array.isArray(events?.data) ? events.data : [];
  const paginatedData = allEvents.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  return (
    <Fragment>
      <div className="d-flex align-items-center justify-content-between p-2">
        <H5 attrH4={{ className: "text-muted m-0" }}>Events</H5>
      </div>

      <DataTable
        data={paginatedData}
        columns={tableColumns}
        striped
        center
        pagination
        paginationServer={true}   // ✅ client side pagination
        paginationTotalRows={allEvents.length}
        paginationPerPage={perPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        paginationDefaultPage={currentPage}
        selectableRows
        onSelectedRowsChange={handleRowSelected}
        clearSelectedRows={toggleDelet}
      />

      <AddModal
        viewModal={viewModal}
        setViewModal={setViewData}
        Modaltoggle={Modaltoggle}
      />
      <EditModal
        category={viewData}
        editModal={editModal}
        setEditModal={setEditModal}
        EditModaltoggle={EditModaltoggle}
      />

      <EventDelete
        isDelete={isDelete}
        setIsDelete={setIsDelete}
        onDelete={handleConfirmDelete}
      />
    </Fragment>
  );
};

export default DataTableComponent;
